export default "__VITE_ASSET__DU0C_5Jf__"